export default __webpack_public_path__ + "static/media/prodvsdisp1.e0f786ca.jpg";